/*   "homepage": "https://www.aaii.com/include/javascript/home/peek/ui", */
/*     "homepage": "https://vmqstocks.com/javascript/peek/ui",  */
import React from "react";
import Floater from "react-floater";
import styled from "styled-components";
import {Link} from 'react-router-dom'
import axios from 'axios';
import './App.css';
import disableScroll from "disable-scroll";
import renderHTML from 'react-render-html';
class Peek extends React.Component {
    constructor(props) {
      
        super(props)
        this.state = {
            peek: [],Rmain:0,mainError:'',idea:'',ins:'', open: false,
          }
         
       this.idea = this.idea.bind(this);
      
    }
   
    idea(val){

    }

    ins(val){

    }
    handleClick = () => {
      this.setState({ open: !this.state.open });
     // console.log(this.state.open)
    };

    
    handlehover = () => {
      this.setState({ open: true });
    
     //  setInterval(   this.setState({ open: false }) , 4000);
     // console.log(this.state.open)
    };

    timer = () => {
      this.setState({ open:false });
      
    };

    componentDidMount() {
     //  console.log('good job',  this.state.open )
      axios.get("https://www.aaii.com/include/api/myportfolio/peek.cfm?id="+this.props.myid )
      .then(response => {
        this.setState({
          peek:  response.data 
        });
        this.setState({idea: this.state.peek[0].tidea}) 
        this.setState({ins: this.state.peek[1].ins}) 
        console.log(response.data );
 
      }).catch(error => {
        //console.log('ERRORR',error)
        this.setState({mainError: '<div className="mainerror"><h1>Oops! Something went wrong!</h1></div>'}) 
    });

          
      }
      
    
      componentWillMount () {
        document.addEventListener('mousedown',this.handleClickme,false) 
      }
      componentWillUnmount() {
        document.removeEventListener('mousedown',this.handleClickme,false) 
      }

      handleClickme= (e)=>{
        
if (this.node.contains(e.target)) {
 // this.setState({ open:true });
  return ; 
}

this.handleclickoutside();
      }

      handleclickoutside(){
        this.setState({ open:false });
      }

      render () {
        const { peek = [] } = this.state;
        const { open } = this.state;
         
        const CustomFloater = ({ closeFn }) => (
  
          <Wrapper ref={node=>this.node=node}>
            <a href="#" style={{textDecoration:'none',float:'right',marginTop:'-20px'}} onClick={this.handleClick}>✖</a>
         {renderHTML(  JSON.parse(JSON.stringify(this.state.idea))  )} 

         {renderHTML(  JSON.parse(JSON.stringify(this.state.ins))  )} 
         
          </Wrapper>
        );


        const Wrapper = styled.div`
        background: linear-gradient(
          to bottom right,
          #EFEFEF  50%,
          #EFEFEF  50%,
          #EFEFEF  60%,
          #EFEFEF  60%
        );
        border-radius: 10px;
        max-width: 400px;
        padding: 3rem 2rem 2rem;
        text-align: left;
        z-index:10000  ;

      `;
      
      const Button = styled.span`
        background-color: #EFEFEF;
        color: #fff;
        display: inline-block;
        padding: 10px;
        border-radius: 4px; 
        z-index:10000  ;
      `;
     
  return (
    <div > 
      {this.props.myshow=='true' ?
    <Floater
    eventDelay ="0"
    showCloseButton  ={false}
    open={this.state.open}
    
    
     ClassName="myfloat"
      component={CustomFloater}
      disableFlip
      placement="bottom-start"
      styles={{
        zIndex:'10000',
        arrow: {
          color: "#EFEFEF",

        },
        tooltip: {
          filter: "none"
        }
      }}
    >
       <a href={this.props.myurl}>
      <button class="myPortNav" onMouseOver={this.handlehover}>
            My Portfolio&nbsp;&nbsp;<span class="varrow-down"></span>
          </button></a>
    </Floater>
    :  <a href={this.props.myurl}>
    <button class="myPortNav" onMouseOver={this.handlehover}>
          My Portfolio&nbsp;&nbsp;<span class="varrow-down"></span>
        </button></a>}
  </div>
    
    
    
  );
  }
}
export default Peek;
